import { Sparkle, Bug, TrendUp, Megaphone } from "@phosphor-icons/react"
import { cn } from "../../../lib/utils"
import { ENTRY_TYPE_CONFIG, type ChangelogEntryType } from "../types"

const ICONS: Record<ChangelogEntryType, React.ElementType> = {
  feature: Sparkle,
  bugfix: Bug,
  improvement: TrendUp,
  announcement: Megaphone,
}

interface ChangelogTypeIconProps {
  type: ChangelogEntryType
  size?: "sm" | "md" | "lg"
  className?: string
}

export function ChangelogTypeIcon({ type, size = "md", className }: ChangelogTypeIconProps) {
  const Icon = ICONS[type]
  const config = ENTRY_TYPE_CONFIG[type]

  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-10 w-10",
  }

  const iconSizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full shrink-0",
        sizeClasses[size],
        config.bgColor,
        className
      )}
    >
      <Icon className={cn(iconSizeClasses[size], config.color)} weight="fill" />
    </div>
  )
}
